var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "vx-card",
    { attrs: { title: "Color", "code-toggler": "" } },
    [
      _c("p", [
        _vm._v(
          "You can change the color of the component with the property color, the parameter allows the main colors and HEX or RGB"
        ),
      ]),
      _c(
        "vs-alert",
        {
          staticClass: "mt-5",
          attrs: { icon: "warning", active: "true", color: "warning" },
        },
        [
          _c("span", [
            _vm._v("Only "),
            _c("strong", [_vm._v("RGB")]),
            _vm._v(" and "),
            _c("strong", [_vm._v("HEX")]),
            _vm._v(" colors are supported."),
          ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "mt-5" },
        [
          _c(
            "vs-tabs",
            { attrs: { color: _vm.colorx } },
            [
              _c(
                "vs-tab",
                {
                  attrs: { label: "Success" },
                  on: {
                    click: function ($event) {
                      _vm.colorx = "success"
                    },
                  },
                },
                [
                  _c("div", { staticClass: "con-tab-ejemplo" }, [
                    _c("p", [
                      _vm._v(
                        "Muffin cupcake candy chocolate cake gummi bears fruitcake donut dessert pie. Wafer toffee bonbon dragée. Jujubes cotton candy gummies chupa chups. Sweet fruitcake cheesecake biscuit cotton candy. Cookie powder marshmallow donut. Candy cookie sweet roll bear claw sweet roll. Cake tiramisu cotton candy gingerbread cheesecake toffee cake. Cookie liquorice dessert candy canes jelly."
                      ),
                    ]),
                    _c("p", { staticClass: "mt-2" }, [
                      _vm._v(
                        "Sweet chocolate muffin fruitcake gummies jujubes pie lollipop. Brownie marshmallow caramels gingerbread jelly beans chocolate bar oat cake wafer. Chocolate bar danish icing sweet apple pie jelly-o carrot cake cookie cake. "
                      ),
                    ]),
                  ]),
                ]
              ),
              _c(
                "vs-tab",
                {
                  attrs: { label: "Danger" },
                  on: {
                    click: function ($event) {
                      _vm.colorx = "danger"
                    },
                  },
                },
                [
                  _c("div", { staticClass: "con-tab-ejemplo" }, [
                    _c("p", [
                      _vm._v(
                        "Biscuit macaroon sugar plum sesame snaps oat cake halvah fruitcake pudding cotton candy. Cheesecake tart wafer soufflé. Chocolate marzipan donut pie soufflé dragée cheesecake. Gummi bears dessert croissant chocolate jujubes fruitcake. Pie cupcake halvah. "
                      ),
                    ]),
                    _c("p", { staticClass: "mt-2" }, [
                      _vm._v(
                        "Tiramisu carrot cake marzipan sugar plum powder marzipan sugar plum bonbon powder. Macaroon jujubes ice cream sugar plum lollipop wafer caramels. Cheesecake chocolate tart cake gingerbread fruitcake cake candy jelly-o. Candy cookie lollipop. Wafer lemon drops chocolate cake gummi bears."
                      ),
                    ]),
                  ]),
                ]
              ),
              _c(
                "vs-tab",
                {
                  attrs: { label: "Warning" },
                  on: {
                    click: function ($event) {
                      _vm.colorx = "warning"
                    },
                  },
                },
                [
                  _c("div", { staticClass: "con-tab-ejemplo" }, [
                    _c("p", [
                      _vm._v(
                        "Brownie ice cream biscuit candy biscuit jujubes. Dessert cake gummies fruitcake chocolate cake sweet roll pastry croissant danish. Pudding chocolate bar sweet roll muffin cake tootsie roll biscuit pastry. Chupa chups dessert donut. Pastry gummi bears tart cookie apple pie sugar plum bear claw."
                      ),
                    ]),
                    _c("p", { staticClass: "mt-2" }, [
                      _vm._v(
                        "Pudding jelly chocolate powder jelly beans icing candy soufflé sweet. Cotton candy sugar plum fruitcake dessert dragée. Toffee chocolate cake chocolate cake oat cake topping macaroon caramels cotton candy. Ice cream lemon drops lollipop."
                      ),
                    ]),
                  ]),
                ]
              ),
              _c(
                "vs-tab",
                {
                  attrs: { label: "Dark" },
                  on: {
                    click: function ($event) {
                      _vm.colorx = "dark"
                    },
                  },
                },
                [
                  _c("div", { staticClass: "con-tab-ejemplo" }, [
                    _c("p", [
                      _vm._v(
                        "Chocolate powder candy canes cake gummies tart donut. Gummi bears sesame snaps bonbon apple pie carrot cake croissant marzipan candy canes jelly-o. Marshmallow sweet cake gummies ice cream toffee. Jelly gingerbread jelly beans tart tart. Jelly-o bonbon jelly-o lemon drops sweet roll jujubes cake. Chocolate cake dessert sugar plum."
                      ),
                    ]),
                    _c("p", { staticClass: "mt-2" }, [
                      _vm._v(
                        "Jelly beans brownie chocolate bar. Jujubes lemon drops apple pie chocolate cake bear claw cupcake chocolate sweet pastry. Pastry carrot cake liquorice. Sesame snaps sugar plum chupa chups tiramisu. Halvah cake chocolate bar jelly beans dragée chocolate halvah pudding pudding."
                      ),
                    ]),
                  ]),
                ]
              ),
              _c(
                "vs-tab",
                {
                  attrs: { label: "RGB | HEX" },
                  on: {
                    click: function ($event) {
                      _vm.colorx = "rgb(16, 233, 179)"
                    },
                  },
                },
                [
                  _c("div", { staticClass: "con-tab-ejemplo" }, [
                    _c("p", [
                      _vm._v(
                        "Gingerbread tart marzipan sweet lemon drops wafer soufflé apple pie lemon drops. Cake pie apple pie icing fruitcake liquorice dessert sugar plum liquorice. Cake liquorice sugar plum cake croissant sweet. Jelly beans donut dessert. Cake jelly-o marzipan candy canes biscuit jelly toffee. Gummi bears jelly-o pastry macaroon gummies gingerbread liquorice bonbon chocolate cake."
                      ),
                    ]),
                    _c("p", { staticClass: "mt-2" }, [
                      _vm._v(
                        "Dragée muffin lemon drops. Cake sweet tootsie roll cupcake cake sugar plum lemon drops. Pudding gingerbread sesame snaps sweet. Gummi bears gingerbread pastry cotton candy sesame snaps toffee. Cake chocolate bonbon marzipan jelly-o powder. Cupcake jujubes fruitcake oat cake powder caramels."
                      ),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("template", { slot: "codeContainer" }, [
        _vm._v(
          '\n<template>\n  <vs-tabs :color="colorx">\n    <vs-tab @click="colorx = \'success\'" label="Success">\n      <div class="con-tab-ejemplo">\n      <span>Jujubes ....</span></div>\n    </vs-tab>\n\n    <vs-tab @click="colorx = \'danger\'" label="Danger">\n      <div class="con-tab-ejemplo">\n      <span>Halvah ...</span></div>\n    </vs-tab>\n\n    <vs-tab @click="colorx = \'warning\'" label="Warning">\n      <div class="con-tab-ejemplo">\n      <span>Chocolate ....</span></div>\n    </vs-tab>\n\n    <vs-tab @click="colorx = \'dark\'" label="Dark">\n      <div class="con-tab-ejemplo">\n      <span>Macaroon ....</span></div>\n    </vs-tab>\n\n    <vs-tab @click="colorx = \'rgb(16, 233, 179)\'" label="RGB | HEX">\n      <div class="con-tab-ejemplo">\n      <span>Cupcake ....</span></div>\n    </vs-tab>\n  </vs-tabs>\n</template>\n\n<script>\nexport default {\n  data:()=>({\n    colorx:\'success\'\n  }),\n}\n</script>\n        '
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }